<template>
  <!-- <Index></Index> -->

  <div class="keep-alive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
      <!-- 不缓存的视图 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template>
  </div>
</template>

<script>
// import Index from '@/components/layout/router-view';
export default {
  // components: {
  //   Index
  // }
};
</script>
<style lang='scss' scoped>
  .keep-alive {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>
